{
	"title": "Weak spots",
	"subtitle": "Gap map: what to review first",
	"intro": {
		"title": "What weak spots are",
		"body": "This is where everything you got wrong in tests and flashcards ends up. The list keeps itself and updates after every check.",
		"bullets": [
			"They appear after tests — nothing to add by hand",
			"A confident mistake moves to the top of the list",
			"Any item turns into flashcards, a test or a tutor session"
		]
	},
	"errorTitle": "Couldn't load",
	"errorDescription": "Check your connection and try again.",
	"retry": "Retry",
	"filterStatus": "Status",
	"filterSeverity": "Severity",
	"filterMaterial": "Material",
	"clearSeverity": "Clear “{level}”",
	"all": "All",
	"active": "Active",
	"resolving": "In progress",
	"resolved": "Resolved",
	"severity": {
		"low": "Low",
		"medium": "Medium",
		"high": "High"
	},
	"severityMeter": {
		"label": "Severity: {level}"
	},
	"summary": {
		"label": "Gap summary",
		"openGaps": "{count, plural, one {open gap} other {open gaps}}",
		"resolved": "{count, plural, one {# resolved} other {# resolved}}"
	},
	"search": "Search by gap topic",
	"view": {
		"byMaterial": "By material",
		"list": "List"
	},
	"group": {
		"unassigned": "Not linked to a material"
	},
	"emptySearchTitle": "Nothing found",
	"emptySearchDescription": "Nothing matched your search. Change the query or reset filters.",
	"emptySearchAction": "Reset search",
	"card": {
		"questions": "{wrong} of {total} wrong",
		"confidentWrong": "Confident & wrong: {count}",
		"luckyGuesses": "Lucky guesses: {count}",
		"detected": "Detected {date}",
		"lastSeen": "Seen {date}",
		"mismatch": "Confidence didn't match the result",
		"closureLabel": "Closure progress",
		"actions": "Actions",
		"recentActions": "Recent close-gap actions"
	},
	"tools": {
		"dialogTitle": "Close this gap",
		"dialogDescription": "Pick a way to work through «{topic}». Chat tools each open a new tutor session.",
		"sections": {
			"recommended": "Recommended"
		},
		"items": {
			"openCourse": {
				"hint": "Continue in the course step for this topic"
			},
			"miniQuiz": {
				"hint": "A short focused quiz on this gap"
			},
			"studyPlan": {
				"hint": "Save a follow-up for this topic in a plan"
			},
			"studyNote": {
				"title": "Study note",
				"hint": "An AI note focused on this weak topic"
			}
		},
		"prompts": {
			"explain": "Explain «{topic}». I got this wrong on a quiz — help me close the gap with a clear explanation and a short check."
		},
		"studyNoteQueued": "Note is generating — opening editor",
		"studyNoteNeedsMaterial": "This gap isn’t linked to a material, so a note can’t be generated",
		"audioNeedsMaterial": "This gap isn’t linked to a material, so audio can’t be started",
		"actionTypes": {
			"repeat-cards": "Flashcards",
			"mini-quiz": "Mini quiz",
			"study-note": "Study note",
			"ai-explain": "Tutor chat",
			"study-plan-add": "Study plan",
			"mindmap": "Diagram",
			"infographic": "Infographic",
			"summary": "Quick recap",
			"audio": "Audio"
		}
	},
	"actions": {
		"closeGap": "Close gap",
		"repeatCards": "Review flashcards",
		"repeatCardsQueued": "Flashcards are being prepared — you'll be notified",
		"miniQuiz": "Mini quiz",
		"miniQuizQueued": "Mini quiz is being generated — opening when ready",
		"aiExplain": "Ask AI",
		"aiExplainQueued": "Opening AI chat for this topic",
		"studyPlanAdd": "To study plan",
		"studyPlanAddDescription": "Pick a plan to add a review section for this topic.",
		"studyPlanAddPlaceholder": "Select a study plan",
		"studyPlanAddEmpty": "You don't have any study plans yet. Create one, then add this topic to it.",
		"studyPlanCreate": "Create plan",
		"studyPlanAddError": "Couldn't add to plan",
		"studyPlanLoading": "Loading plans…",
		"error": "Couldn't complete the action",
		"cancel": "Cancel",
		"dismiss": "Dismiss",
		"markResolved": "Mark resolved",
		"openTopicGap": "Close in course"
	},
	"back": "Back to test results",
	"emptySuccessTitle": "No weak spots",
	"emptySuccessDescription": "You've got this material under control. Take a quiz and AI will flag topics worth reviewing.",
	"emptySuccessAction": "Go to quizzes",
	"emptyResolvedTitle": "No resolved gaps yet",
	"emptyResolvedDescription": "Topics you've worked through and closed will show up here.",
	"emptyFilterTitle": "No gaps with this severity",
	"emptyFilterDescription": "Nothing matched the selected filter. Clear it to see all gaps.",
	"emptyFilterAction": "Clear filter",
	"dismiss": {
		"title": "Dismiss weak spot?",
		"description": "It won't appear in recommendations. You can restore it from archive.",
		"confirm": "Dismiss",
		"cancel": "Cancel"
	}
}
